import {
    ERROR_MESSAGE,
    LOADED,
    LOADING,
    SUCCESS_MESSAGE,
    VALIDATION_ERROR,
} from './types';

import history from '../history';
import api from './apis';
import axios from 'axios';

// ========================Get data==========================
export const getAllProducts = (page,name,product_id,active) => async (dispatch) => {
  
    dispatch({type: LOADING});
    try {
      const response = await api(localStorage.getItem("token")).get(
        `/product?p=${page == undefined ? 1 : page}&name=${name ? name : ''}&product=${product_id ? product_id : ''}&active=${active ? active : ''}`
      );
      if(response.status === 200){

        dispatch({type: LOADED});
        return response.data
      }
      
      
    } catch (err) {
      /* =============Start========== */
      if(err?.response?.status === 451)
        {
            history.push('/pending-verification')
        }
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        
        if(err.message == 'Network Error')
        {
            history.push('/maintenance')
            return
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/404') });
        dispatch({type: LOADED});
      /* ===========End============*/}
  };

// ========================Create Product=========================
export const createProduct = (data) => async (dispatch) => {
  
// console.log(data)
  dispatch({type: LOADING});
  const object = {
    name : data.name,
    life_time : data.life_time,
    price : data.price,
    color : 'none',
    weight : data.weight,
    weight_unit : data.weight_unit,
    active : data.active,
    description : data.description
  };
  if(data.image){
    object.image = data.image.fileList[0].response.name
  }

  if(data.thumbnail){
    object.thumbnail = data.thumbnail.fileList[0].response.name
  }
  
  try {
    const response = await api(localStorage.getItem("token")).post(
      "product/create",
      { ...object }
    );

    if (response.status === 201) {
      
    dispatch({type: LOADED});
    dispatch({ type: SUCCESS_MESSAGE, payload: response.data.message });
    return response.status
    }
  } catch (err) {
    /* =============Start========== */
      if(err?.response?.status === 422){
        err.response.data.errors.map(item => {
            dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
        })
      }
      
      if(err?.response?.status === 451)
        {
          history.push('/pending-verification')
        }
      if(err?.response?.status === 401 || err?.response?.status === 403 ){
          dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
          localStorage.clear();
          history.push('/login')
      }
      
          if(err.message == 'Network Error')
          {
              history.push('/maintenance')
              return
          }
      dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/notFound') });
      dispatch({type: LOADED});
  }
};

// ========================Update Product=========================
export const updateProduct = (data,id) => async (dispatch) => {
  
// console.log(data)
  dispatch({type: LOADING});
  const object = {
    product_id: id,
    name : data.name,
    life_time : data.life_time,
    price : data.price,
    color : 'none',
    weight :  data.weight,
    weight_unit : data.weight_unit,
    active : data.active,
    description : data.description
  };
  // if(data.image){
  //   object.image = data.image.fileList[0].response.name
  // }

  // if(data.thumbnail){
  //   object.thumbnail = data.thumbnail.fileList[0].response.name
  // }
  
  try {
    const response = await api(localStorage.getItem("token")).patch(
      "product/update",
      { ...object }
    );

    if (response.status === 201) {
      
    dispatch({type: LOADED});
    dispatch({ type: SUCCESS_MESSAGE, payload: response.data.message });
    return response.status
    
    }
  } catch (err) {
    /* =============Start========== */
      if(err?.response?.status === 422){
        err.response.data.errors.map(item => {
            dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
        })
      }
      
      if(err?.response?.status === 451)
        {
          history.push('/pending-verification')
        }
      if(err?.response?.status === 401 || err?.response?.status === 403 ){
          dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
          localStorage.clear();
          history.push('/login')
      }
      
          if(err.message == 'Network Error')
          {
              history.push('/maintenance')
              return
          }
      dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/notFound') });
      dispatch({type: LOADED});
  }
};


// ========================Get Product details==========================
export const getProductDetails = (product_id) => async (dispatch) => {
  
  dispatch({type: LOADING});
  try {
    const response = await api(localStorage.getItem("token")).get(
      `/product/detail?product=${product_id ? product_id : ''}`
    );
    if(response.status === 200){

      dispatch({type: LOADED});
      return response.data.product
    }
    
    
  } catch (err) {
    /* =============Start========== */
    console.log(err)
    if(err?.response?.status === 451)
      {
          history.push('/pending-verification')
      }
      if(err?.response?.status === 422){
        err.response.data.errors.map(item => {
            dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
        })
      }
      if(err?.response?.status === 401 || err?.response?.status === 403 ){
          dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
          localStorage.clear();
          history.push('/login')
      }
      
          if(err.message == 'Network Error')
          {
              history.push('/maintenance')
              return
          }
      dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/notFound') });
      dispatch({type: LOADED});
    /* ===========End============*/}
};


// ========================Update Product auth=========================
export const updateProductAuth = (product,status) => async (dispatch) => {
// console.log(status)
    dispatch({type: LOADING});
    const object = {
      product: product,
      active : status
    };
    
    try {
      const response = await api(localStorage.getItem("token")).patch(
        "product/auth",
        { ...object }
      );
  
      if (response.status === 201) {
        
      dispatch({type: LOADED});
      dispatch({ type: SUCCESS_MESSAGE, payload: response.data.message });
      return response.status
      
      }
    } catch (err) {
      /* =============Start========== */
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        
      if(err?.response?.status === 451)
      {
        history.push('/pending-verification')
      }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        
        if(err.message == 'Network Error')
        {
            history.push('/maintenance')
            return
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/notFound') });
        dispatch({type: LOADED});
    }
  };
    
  
// // ========================Remove Product Image=========================
// export const updateProductImage = (data,product) => async (dispatch) => {
  
//   // console.log(data)
//     dispatch({type: LOADING});
//     const object = {
//       file : data.thumbnail.fileList[0].response.name,
//       product : product,
//       type : 'product-thumbnail'
//     };
   
    
//     try {
//       const response = await api(localStorage.getItem("token")).patch(
//         "file/user/update",
//         { ...object }
//       );
  
//       if (response.status === 201) {
        
//       dispatch({type: LOADED});
//       console.log(response)
//       dispatch({ type: SUCCESS_MESSAGE, payload: response.data.message });
//       return response.status
//       }
//     } catch (err) {
//       /* =============Start========== */
//         if(err?.response?.status === 422){
//           err.response.data.errors.map(item => {
//               dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
//           })
//         }
//         if(err?.response?.status === 401 || err?.response?.status === 403 ){
//             dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
//             localStorage.clear();
//             history.push('/login')
//         }
//         dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/notFound') });
//         dispatch({type: LOADED});
//     }
//   };
  
// ========================Update Product Image=========================
export const updateProductImage = (data,product, type) => async (dispatch) => {
  
  // console.log(data)
    dispatch({type: LOADING});
    const object = {
      file : null,
      product : product,
      type : type
    };
    const object1 = {
      file : data.thumbnail.fileList[0].response.name,
      product : product,
      type : type
    };
   
    
    try {
      const response = await axios (`${process.env.REACT_APP_API_BASE_URL}/client/file/user/delete`,
      {
          headers: {
              'content-type': 'application/json',
              'authorization': `Bearer ${localStorage.getItem("token")}`
          },
          data: {
            file : 'null',
            product : product,
            type : type
          },
          method: 'delete'
      
      })
      if(response.status === 201){
        const res = await api(localStorage.getItem("token")).patch(
              "file/user/update",
              { ...object1 }
            );
  
      if (res.status === 201) {
        dispatch({type: LOADED});
     
        dispatch({ type: SUCCESS_MESSAGE, payload: res.data.message });
        return res.status
      }
      
      }
    } catch (err) {
      /* =============Start========== */
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        
      if(err?.response?.status === 451)
      {
        history.push('/pending-verification')
      }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        
        if(err.message == 'Network Error')
        {
            history.push('/maintenance')
            return
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/notFound') });
        dispatch({type: LOADED});
    }
  };